import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

export interface DispositionResponse {
  dispositionTasks: fhirTypes.Task[];
}

export const useDisposition = ({
  encounterId,
  carePlanId,
  enabled,
}: { encounterId: string; carePlanId: string; enabled: boolean }) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApi<DispositionResponse>({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<DispositionResponse>(
          `/charting/careplan/${carePlanId}/disposition`,
        );

        return response.data;
      },
      queryKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.DEFAULT({
          patientId,
          encounterId,
          carePlanId,
        }),
    },
  });
};
